import { render, staticRenderFns } from "./ComentarioModal.vue?vue&type=template&id=1f5cfb24&scoped=true"
import script from "./ComentarioModal.vue?vue&type=script&lang=js"
export * from "./ComentarioModal.vue?vue&type=script&lang=js"
import style0 from "./ComentarioModal.vue?vue&type=style&index=0&id=1f5cfb24&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "1f5cfb24",
  null
  
)

export default component.exports